import appsApi from "../api/apps"
import useApiSource from "./useApiSource"

const usePublicApp = (id: string) => {
    const {data, setData} = useApiSource(appsApi.getApp.bind(appsApi, id))

    return {app: data, setApp: setData}
}

export default usePublicApp